import { FormControlLabel, Link, Radio, RadioGroup, Typography } from "@mui/material";
import React from "react";
import { FormLine } from "../forms/FormLine";
import { fetchLutPickList } from "./LUTModal";

interface RadioLutListProps {
	fl: FormLine;
	checkChange: () => void;
	disabled: boolean;
}

function getDisplayLabel(item: any) {
	let display = "";
	if (item.sc_code) {
		display += item.sc_code + " - ";
	}
	display += item.display_exp;
	return display;
}

function valuesMatch(a: any, b: any) {
	if (a == null || b == null) return false;
	return a.toString().toLowerCase() === b.toString().toLowerCase();
}

export default function RadioLutList(props: RadioLutListProps) {
	const { fl, checkChange, disabled } = props;
	const [options, setOptions] = React.useState([] as Array<any>);
	const [loading, setLoading] = React.useState(true);
	const modifiable = fl.isModifiable && !disabled;
	const currentValue = fl.lutValue?.value?.toString() ?? "";

	const loadOptions = React.useCallback(() => {
		if (!fl.lutValue) return;
		setLoading(true);
		fetchLutPickList(fl.lutValue, {
			eventGroup: fl.eventGroupsId,
			eventCategory: fl.eventCategoryId,
		})
			.then((list) => {
				setOptions(list);
				const match = list.find((item) => valuesMatch(item.code_field, fl.lutValue?.value));
				if (match) {
					(fl.lutValue as any).description = match.display_exp;
					(fl.lutValue as any).prompt = match.prompt_field;
				}
			})
			.finally(() => setLoading(false));
	}, [fl]);

	React.useEffect(() => {
		loadOptions();
		fl.refreshRadioLut = loadOptions;
		return () => {
			fl.refreshRadioLut = undefined;
		};
	}, [fl, loadOptions]);

	const handleChange = (codeField: string) => {
		const selected = options.find((item) => valuesMatch(item.code_field, codeField));
		if (!selected) return;

		(fl.lutValue as any).value = selected.code_field;
		(fl.lutValue as any).description = selected.display_exp;
		(fl.lutValue as any).prompt = selected.prompt_field;
		checkChange();
	};

	const clearSelection = () => {
		(fl.lutValue as any).value = null;
		(fl.lutValue as any).description = null;
		(fl.lutValue as any).prompt = null;
		checkChange();
	};

	if (loading) {
		return <Typography variant="body2">Loading...</Typography>;
	}

	return (
		<>
			<RadioGroup name={fl.formLinesId} value={currentValue} onChange={(_, val) => handleChange(val)}>
				{options.map((item, idx) => {
					const val = item.code_field?.toString() ?? "";
					return (
						<FormControlLabel
							key={idx}
							value={val}
							disabled={!modifiable}
							label={getDisplayLabel(item)}
							control={<Radio size="small" />}
							sx={{ marginLeft: 0, alignItems: "flex-start" }}
						/>
					);
				})}
			</RadioGroup>
			{modifiable && fl.lutValue?.value && (
				<Link component="button" type="button" variant="body2" onClick={clearSelection} sx={{ cursor: "pointer", marginTop: 0.5 }}>
					Clear Selection
				</Link>
			)}
		</>
	);
}
